// ============================================
// loyalty.js — Puntos de fidelidad del socio (Medusa v2)
// ============================================

import { MEDUSA_API_URL, MEDUSA_API_KEY } from './config';

// GET autenticado: saldo + historial de puntos del cliente.
export async function getMyLoyalty(token) {
  const res = await fetch(`${MEDUSA_API_URL}/store/loyalty/me`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-publishable-api-key': MEDUSA_API_KEY,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.message || `Error ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data; // { balance, transactions: [{ id, points, reason, note, date }] }
}
